import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Slider from "react-slick";
import { ContactForm } from "@stories/molecules/ContactForm/ContactForm";
import sliderImg1 from "assets/images/home/leading-socials.webp";
import FooterLogo from "assets/images/home/footer-logo-new.webp";
import instgram from "assets/images/icons/instgram-logo.webp";
import linkedin from "assets/images/icons/linkedin-logo.webp";
import Logo from "assets/images/home/SocialPro_Blue.png";
import "./style.css";

export const RequestDemo = () => {
  const [IsSticky, setIsSticky] = useState(false);
  const [IsActive, setIsActive] = useState(false);
  const [IsMenuActive, setIsMenuActive] = useState(false);

  const handleMenu = () => {
    setIsMenuActive(!IsMenuActive);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 7000,
    cssEase: "linear",
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  return (
    <>
      {/* Hero Section  */}

      <header className={IsSticky ? "header-sticky" : "header-default"}>
        <div className="container-new">
          <div className="navigation">
            <a href="/" className="site-logo">
              <img src={Logo} alt="socialpro" />
            </a>
            <ul>
              <li>
                <a href="/">Features</a>
                <ul className="dropdown-content">
                  <li>
                    <a href="#">Co-ordinate</a>
                  </li>
                  <li>
                    <a href="#">Monitor</a>
                  </li>

                  <li>
                    <a href="/">Report</a>
                  </li>
                  <li>
                    <a href="/">Smart Directory</a>
                  </li>
                  <li>
                    <a href="#apiInteg">API Integration</a>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/request-demo">Request a Demo</Link>
              </li>
              <li>
                <a href="/login" className="nav-login">
                  <svg
                    data-bbox="0 0 50 50"
                    data-type="shape"
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 50 50"
                    fill="#0099fa"
                  >
                    <g>
                      <path d="M25 48.077c-5.924 0-11.31-2.252-15.396-5.921 2.254-5.362 7.492-8.267 15.373-8.267 7.889 0 13.139 3.044 15.408 8.418-4.084 3.659-9.471 5.77-15.385 5.77m.278-35.3c4.927 0 8.611 3.812 8.611 8.878 0 5.21-3.875 9.456-8.611 9.456s-8.611-4.246-8.611-9.456c0-5.066 3.684-8.878 8.611-8.878M25 0C11.193 0 0 11.193 0 25c0 .915.056 1.816.152 2.705.032.295.091.581.133.873.085.589.173 1.176.298 1.751.073.338.169.665.256.997.135.515.273 1.027.439 1.529.114.342.243.675.37 1.01.18.476.369.945.577 1.406.149.331.308.657.472.98.225.446.463.883.714 1.313.182.312.365.619.56.922.272.423.56.832.856 1.237.207.284.41.568.629.841.325.408.671.796 1.02 1.182.22.244.432.494.662.728.405.415.833.801 1.265 1.186.173.154.329.325.507.475l.004-.011A24.886 24.886 0 0 0 25 50a24.881 24.881 0 0 0 16.069-5.861.126.126 0 0 1 .003.01c.172-.144.324-.309.49-.458.442-.392.88-.787 1.293-1.209.228-.232.437-.479.655-.72.352-.389.701-.78 1.028-1.191.218-.272.421-.556.627-.838.297-.405.587-.816.859-1.24a26.104 26.104 0 0 0 1.748-3.216c.208-.461.398-.93.579-1.406.127-.336.256-.669.369-1.012.167-.502.305-1.014.44-1.53.087-.332.183-.659.256-.996.126-.576.214-1.164.299-1.754.042-.292.101-.577.133-.872.095-.89.152-1.791.152-2.707C50 11.193 38.807 0 25 0"></path>
                    </g>
                  </svg>
                  <span>Login</span>
                </a>
              </li>
            </ul>

            {IsActive === false ? (
              <button type="button" className="hamburger-menu" onClick={() => setIsActive(!IsActive)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0099fa" height={32}>
                  <path
                    fillRule="evenodd"
                    d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            ) : (
              <button type="button" className="hamburger-menu" onClick={() => setIsActive(!IsActive)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0099fa" height={32}>
                  <path
                    fillRule="evenodd"
                    d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
        {/* Mob Navigation  */}
        {IsActive && (
          <div className="container-new">
            <div className="mob-nav">
              <ul>
                <li>
                  <button
                    onClick={handleMenu}
                    className={IsMenuActive === true ? "dropdown-link svg-rotate" : "dropdown-link"}
                  >
                    Features
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="#0099fa"
                      fill="none"
                      height={19}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </button>
                  <ul
                    className={IsMenuActive === true ? "mob-nav-dropdown mob-nav-dropdown-active" : "mob-nav-dropdown"}
                  >
                    <li>
                      <a href="/">Monitor</a>
                    </li>
                    <li>
                      <a href="/">Approve</a>
                    </li>
                    <li>
                      <a href="/">Report</a>
                    </li>
                    <li>
                      <a href="/">Directory</a>
                    </li>
                    <li>
                      <a href="/">API Integration</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="">Request a Demo</a>
                </li>
                <li>
                  <a href="/login" className="nav-login">
                    <svg
                      data-bbox="0 0 50 50"
                      data-type="shape"
                      xmlns="http://www.w3.org/2000/svg"
                      width="35"
                      height="35"
                      viewBox="0 0 50 50"
                      fill="#0099fa"
                    >
                      <g>
                        <path d="M25 48.077c-5.924 0-11.31-2.252-15.396-5.921 2.254-5.362 7.492-8.267 15.373-8.267 7.889 0 13.139 3.044 15.408 8.418-4.084 3.659-9.471 5.77-15.385 5.77m.278-35.3c4.927 0 8.611 3.812 8.611 8.878 0 5.21-3.875 9.456-8.611 9.456s-8.611-4.246-8.611-9.456c0-5.066 3.684-8.878 8.611-8.878M25 0C11.193 0 0 11.193 0 25c0 .915.056 1.816.152 2.705.032.295.091.581.133.873.085.589.173 1.176.298 1.751.073.338.169.665.256.997.135.515.273 1.027.439 1.529.114.342.243.675.37 1.01.18.476.369.945.577 1.406.149.331.308.657.472.98.225.446.463.883.714 1.313.182.312.365.619.56.922.272.423.56.832.856 1.237.207.284.41.568.629.841.325.408.671.796 1.02 1.182.22.244.432.494.662.728.405.415.833.801 1.265 1.186.173.154.329.325.507.475l.004-.011A24.886 24.886 0 0 0 25 50a24.881 24.881 0 0 0 16.069-5.861.126.126 0 0 1 .003.01c.172-.144.324-.309.49-.458.442-.392.88-.787 1.293-1.209.228-.232.437-.479.655-.72.352-.389.701-.78 1.028-1.191.218-.272.421-.556.627-.838.297-.405.587-.816.859-1.24a26.104 26.104 0 0 0 1.748-3.216c.208-.461.398-.93.579-1.406.127-.336.256-.669.369-1.012.167-.502.305-1.014.44-1.53.087-.332.183-.659.256-.996.126-.576.214-1.164.299-1.754.042-.292.101-.577.133-.872.095-.89.152-1.791.152-2.707C50 11.193 38.807 0 25 0"></path>
                      </g>
                    </svg>
                    <span>Login</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}
      </header>

      {/* Contact Section  */}
      <div
        style={{ background: "linear-gradient(55deg, rgba(255,255,255,1) 1%, rgba(165,218,255,1) 100%)" }}
        id="contact"
      >
        <div className="container-new contact-section">
          <div className="contact-form-new">
            <h4>Get in Touch</h4>
            <h5>Streamline and automate your project today</h5>
            <ContactForm />
          </div>
          <div className="contact-slider">
            <Slider {...settings}>
              <div>
                <div className="contact-slider-img">
                  <img src={sliderImg1} alt="sliderImg" />
                </div>
                <div className="contact-slider-content">
                  <h4>CO-ORDINATE</h4>
                  <h3>Streamlined data collection</h3>
                  <div className="slider-content-list">
                    <ul>
                      <li>Easy setup and seamless implementation.</li>
                      <li>Track reporting from subcontractors.</li>
                      <li>Automated input data collection with document upload.</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div>
                <div className="contact-slider-img">
                  <img src={sliderImg1} alt="sliderImg" />
                </div>
                <div className="contact-slider-content">
                  <h4>MONITOR</h4>
                  <h3>Manage & review in one place</h3>
                  <div className="slider-content-list">
                    <ul>
                      <li>Cloud-based platform accessible from any device.</li>
                      <li>Project-level analytics on performance against targets.</li>
                      <li>Connections to certified suppliers across various social targets.</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div>
                <div className="contact-slider-img">
                  <img src={sliderImg1} alt="sliderImg" />
                </div>
                <div className="contact-slider-content">
                  <h4>REPORT</h4>
                  <h3>Improve accuracy and transparency</h3>
                  <div className="slider-content-list">
                    <ul>
                      <li>User-friendly dashboard.</li>
                      <li>Bespoke commentary on highlights and challenges.</li>
                      <li>Analytics designed for concise communication with stakeholders.</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div>
                <div className="contact-slider-img">
                  <img src={sliderImg1} alt="sliderImg" />
                </div>
                <div className="contact-slider-content">
                  <h4>SEARCH </h4>
                  <h3>Smart directory of verified social enterprises</h3>
                  <div className="slider-content-list">
                    <ul>
                      <li>Use AI to recommend suppliers to help support shortfalls.</li>
                      <li>Simply search by business name, impact category and location.</li>
                      <li>Identify best-fit products and services where there is local capacity.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>

      <div style={{ background: "linear-gradient(90deg, rgba(0,100,196,1) 0%, rgba(0,170,255,1) 100%)" }}>
        <div className="container-new footer-flex">
          <div className="footer-links">
            <a href="/" className="footer-logo-new">
              <img src={FooterLogo} alt="FooterLogo" />
            </a>
            <div className="footer-social">
              <ul className="social-links">
                <li>
                  <a href="https://www.instagram.com/socialpro.app/" target="_blank">
                    <img src={instgram} alt="instgram" />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/socialpro-app/" target="_blank">
                    <img src={linkedin} alt="linkedin" />
                  </a>
                </li>
              </ul>
              <p>
                <span> SOCIALPRO™</span> (2023)
              </p>
            </div>
          </div>
          <div className="footer-links">
            <h4>Service</h4>
            <ul>
              <li>
                <a href="/">Request a demo</a>
              </li>
              <li>
                <a href="/">Start a project</a>
              </li>
              <li>
                <a href="/">Partnerships</a>
              </li>
              <li>
                <a href="/">API integration</a>
              </li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>FEATURES</h4>
            <ul>
              <li>
                <a href="/">Mentor</a>
              </li>
              <li>
                <a href="/">Approve</a>
              </li>
              <li>
                <a href="/">Report</a>
              </li>
              <li>
                <a href="/">Smart Directory</a>
              </li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>ABOUT</h4>
            <ul>
              <li>
                <a href="/">Contact us</a>
              </li>
              <li>
                <a href="/">Definitions</a>
              </li>
              <li>
                <a href="/">Privacy Policy</a>
              </li>
              <li>
                <a href="/">Terms & Conditions</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
